import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zh from './resources/zh.json';
import en from './resources/en.json';
import th from './resources/th.json';

const resources = {
  zh: {
    translation: zh,
  },
  en: {
    translation: en,
  },
  th: {
    translation: th,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'zh',
  fallbackLng: 'zh',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
